import React from 'react';
import { Redirect } from 'react-router-dom';

import CategoryPage from './CategoryPage';

import type { RouteComponentProps } from 'react-router-dom';

const collectionPageRedirectionMap = {
  'artificial-intelligence': 'artificial-intelligence',
  'atlassian-ventures': 'atlassian-ventures',
  changemakers: 'changemakers',
  'codegeist-unleashed-apps': 'artificial-intelligence',
} as const;

const categoryPageRedirectionMap = {
  'agile-at-scale': 'project-management?useCases=Agile+Methodology',
  'analytics-reports': 'data-analytics?useCases=Data+Management',
  'asset-management': 'it-support?useCases=Asset+Management',
  'business-teams': 'sales-customer-relations',
  'charts-diagrams': 'design-diagramming?useCases=Charts/Graphs',
  'chat-integrations': 'content-communication?useCases=Chat',
  'continuous-integration': 'software-development?useCases=CI/CD',
  crm: 'sales-customer-relations?useCases=CRM',
  'customer-support': 'it-support?useCases=IT+Support',
  'design-tools': 'design-diagramming',
  devops: 'software-development',
  'devops/build': 'software-development?useCases=Build+Management',
  'devops/continuous-feedback': 'software-development?useCases=Feedback+and+Surveys',
  'devops/deploy': 'software-development?useCases=CI/CD',
  'devops/discover': 'software-development',
  'devops/observe': 'software-development?useCases=Monitoring',
  'devops/operate': 'software-development',
  'devops/plan': 'software-development',
  'devops/test': 'software-development?useCases=Testing+%26+QA',
  'document-management': 'content-communication?useCases=Document+Management',
  'it-service-management': 'it-support',
  monitoring: 'software-development?useCases=Monitoring',
  'software-teams': 'software-development',
  'test-management': 'software-development?useCases=Testing+%26+QA',
  'themes-styles': 'design-diagramming?useCases=Themes+%26+Styles',
} as const;

const searchPageRedirectionMap = {
  workflow: 'query=&product=jira&useCases=Workflow',
  'time-tracking': 'query=&product=jira&useCases=Time+Tracking',
} as const;

type TParams = {
  slug: string;
  subSlug?: string;
};

const AddonCategoryPageRouteProcessor = (props: RouteComponentProps<TParams>) => {
  const {
    match: { params },
  } = props;

  if (collectionPageRedirectionMap[params.slug]) {
    return <Redirect to={`/collections/${collectionPageRedirectionMap[params.slug]}`} />;
  }

  if (categoryPageRedirectionMap[`${params.slug}/${params.subSlug}`]) {
    return (
      <Redirect
        to={`/categories/${categoryPageRedirectionMap[`${params.slug}/${params.subSlug}`]}`}
      />
    );
  }

  if (categoryPageRedirectionMap[params.slug]) {
    return <Redirect to={`/categories/${categoryPageRedirectionMap[params.slug]}`} />;
  }

  if (searchPageRedirectionMap[params.slug]) {
    return <Redirect to={`/search?${searchPageRedirectionMap[params.slug]}`} />;
  }

  return <CategoryPage />;
};

export default AddonCategoryPageRouteProcessor;
